import type { FunctionComponent } from 'react';

import { Phone } from '@/core/tamagoshi/icons/Phone';
import { Typography } from '@/domains/core/tamagoshiTailwind/components/Typography/Typography';
import { twMerge } from '@/domains/core/tamagoshiTailwind/util/twMerge';
import ContactService from '@/domains/proB2BAnimation/components/ContactService/ContactService';
import {
  headerSubheaderContactB2bTelLink,
  headerSubheaderContactB2bTelNumber,
} from '@/domains/productDiscovery/HeaderLeonidas/translations';
import { Accordion } from '@/domains/retention/Footer/modules/Accordion/Accordion';
import {
  footerContactServiceCallPrice,
  footerContactServiceTitle,
} from '@/domains/retention/Footer/translations';

export interface SupportProps {
  className?: string;
}

export const Support: FunctionComponent<SupportProps> = ({
  className = '',
}) => (
  <div
    className={twMerge(
      `mt-[12px] border-t border-solid border-foundation-inverted pt-l
      desktop:mt-0 desktop:border-0`,
      className,
    )}
  >
    <Accordion title={footerContactServiceTitle} isExpandable={false}>
      <a
        className="mb-s mt-0 flex flex-row items-center justify-start
          text-accent-primary no-underline hover:underline"
        href={headerSubheaderContactB2bTelLink}
      >
        <Phone className="mr-xs" width={16} height={16} />
        <Typography scale="body2" weight="semibold">
          {headerSubheaderContactB2bTelNumber}
        </Typography>
      </a>
      <Typography scale="small">
        <ContactService splitWeekend />
        <br />
        {footerContactServiceCallPrice}
      </Typography>
    </Accordion>
  </div>
);
